import { render, staticRenderFns } from "./ModalVisualizacaoCarsVinculadosMonitoramentoSocioambiental.vue?vue&type=template&id=9020afc2&lang=pug"
import script from "./ModalVisualizacaoCarsVinculadosMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./ModalVisualizacaoCarsVinculadosMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizacaoCarsVinculadosMonitoramentoSocioambiental.vue?vue&type=style&index=0&id=9020afc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports